import React from 'react';
import LocalFileStorage from '../LocalFileStorage';

type Props = React.AudioHTMLAttributes<HTMLAudioElement> & {
	localFileStorage: LocalFileStorage;
	dbKey: IDBValidKey;
};
type State = {
	ready: boolean;
	src: string;
};

class LocalAudio extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			ready: false,
			src: '',
		};
	}

	async componentDidMount() {
		const { dbKey, localFileStorage } = this.props;

		const src = await localFileStorage.getAudioSrc(dbKey);
		this.setState({
			ready: true,
			src,
		});
	}

	async componentDidUpdate(prevProps: Props) {
		const { dbKey, localFileStorage } = this.props;

		if (prevProps.dbKey !== dbKey) {
			const src = await localFileStorage.getAudioSrc(dbKey);
			this.setState({
				ready: true,
				src,
			});
		}
	}

	render() {
		const { dbKey, localFileStorage, ...audioProps } = this.props;
		const { ready, src } = this.state;

		if (ready) {
			return (
				<audio
					src={src}
					{...audioProps}
				/>
			);
		}

		return (
			<div>Loading audio...</div>
		);
	}
}

export default LocalAudio;
